import { MedplumProvider } from '@medplum/react'
import { MedplumClient } from '@medplum/core'
import { ReactQueryContext } from '@/components/ReactQueryContext.tsx'
import { config } from '@/config'
import { ModalsProvider } from '@mantine/modals'
import { createTheme, MantineProvider } from '@mantine/core'
import { BrowserRouter } from 'react-router-dom'
import { Notifications } from '@mantine/notifications'
import { useMemo } from 'react'
import { SessionProvider, SessionWarningModals } from './session'
import { LDUserIdentifier } from './LDUserIdentifier'

const theme = createTheme({
  headings: {
    sizes: {
      h1: {
        fontSize: '1.125rem',
        fontWeight: '500',
        lineHeight: '2.0',
      },
    },
    fontFamily: 'Mulish, sans-serif',
  },
  primaryColor: 'blue',
  colors: {
    blue: [
      '#F0F7FF',
      '#D0E1F2',
      '#316dab',
      '#316dab',
      '#316dab',
      '#316dab',
      '#316dab',
      '#316dab',
      '#316dab',
      '#316dab',
    ],
  },
  components: {
    Checkbox: {
      styles: {
        input: {
          '--checkbox-color': '#316dab',
        },
      },
    },
    Tabs: {
      defaultProps: {
        color: 'blue',
      },
    },
    // PD-1901 — every date picker marks today; the look lives in index.css.
    Calendar: {
      defaultProps: {
        highlightToday: true,
      },
    },
  },
})

function Provider({ children }: { children: React.ReactNode; accessToken?: string }) {
  const medplum = useMemo(() => {
    return new MedplumClient({
      cacheTime: 5000,
      baseUrl: config.baseUrl,
    })
  }, [])

  return (
    <MedplumProvider medplum={medplum}>
      <MantineProvider theme={theme}>
        <ModalsProvider labels={{ confirm: 'Submit', cancel: 'Cancel' }}>
          <SessionProvider>
            <SessionWarningModals />
            <LDUserIdentifier />
            {children}
          </SessionProvider>
        </ModalsProvider>
        <Notifications key="notification" position="bottom-right" />
      </MantineProvider>
    </MedplumProvider>
  )
}

export function LayoutContext({ children }: { children: React.ReactNode; accessToken?: string }) {
  return (
    <ReactQueryContext>
      <BrowserRouter>
        <Provider>{children}</Provider>
      </BrowserRouter>
    </ReactQueryContext>
  )
}
